import {
  WSButton,
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { IPayableSchema } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useHistory } from "react-router-dom";
import { useQueryWorkLog } from "../../../query/workLog/queries/useQueryWorkLog";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { getPathWorkLogPayerDetails } from "../paths";

type Props = {
  payable: IPayableSchema;
};

function formatCancelledDate(date?: Date | string): string {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
}

export const CancelledPayableWorkLogInfo: React.FC<Props> = ({ payable }) => {
  const history = useHistory();
  const queryFeatureFlags = useFeatureFlags();

  const workLogId = (payable as any).workLogId as string | undefined;

  const queryWorkLog = useQueryWorkLog(workLogId!, {
    enabled: !!workLogId && !!queryFeatureFlags.data?.workLogReviewWorkflow
  });

  const workLog = queryWorkLog.data;
  const cancelledAt = payable.events?.cancelledAt;
  const payerComment = (workLog as any)?.payerOwnedData?.comment as
    | string
    | undefined;

  return (
    <WSList gap="L">
      <WSElement>
        <WSText.Heading5>Cancelled</WSText.Heading5>
        {cancelledAt && (
          <WSText.ParagraphSm color="gray500" mt="XS">
            This invoice was cancelled on {formatCancelledDate(cancelledAt)}
          </WSText.ParagraphSm>
        )}
      </WSElement>

      {workLogId && (
        <WSButton.Link
          onClick={() => history.push(getPathWorkLogPayerDetails(workLogId))}
          rightIcon="chevron-right"
        >
          View cancelled work log
        </WSButton.Link>
      )}

      {payerComment && (
        <WSCard>
          <WSFlexBox.CenterY gap="M" mb="S">
            <WSText.ParagraphSm weight="medium">Comment</WSText.ParagraphSm>
            <WSPill icon="view" text="Public" theme="neutral" />
          </WSFlexBox.CenterY>
          <WSText.ParagraphSm color="gray600">
            {payerComment}
          </WSText.ParagraphSm>
        </WSCard>
      )}
    </WSList>
  );
};
